import { Padding } from '@mui/icons-material'
import {
  Box, Button, Divider, Typography, CircularProgress,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper,
  IconButton,
  TextField,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Grid,
} from '@mui/material'
import { EyeIcon, Plus, SearchIcon } from 'lucide-react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import { wrap } from 'lodash';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import Context from '../../context/Context';
import DeleteConfirm from "../../Common/DeleteConfirm"
import { useDebounce } from "../../hooks/useDebounce";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import apiClient from '../../utils/apiClient';

const DisplayTechnician = () => {

   const { isConfirmDeleteModelOpen,setIsConfirmDeleteModelOpen,itemIdToDelete,
        confirmDelete } = useContext(Context);
  const navigate = useNavigate()
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [status, setStatus] = useState('');
  const [error, setError] = useState(" ");
  const [technicians, setTechnicians] = useState([]);
  const [techinicianType, setTechnicianType] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTechnician, setSelectedTechnician] = useState(null);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const open = Boolean(anchorEl);
  const getTechnicians = async ({ isActive, search, page, pageSize, technicianType } = {}) => {
    setLoading(true)
    const params = new URLSearchParams();
if (isActive !== undefined && isActive !== '') {
  params.append('isActive', isActive);
}
    // if (isActive !== undefined) params.append('isActive', isActive);
    if (search) params.append('search', search);
    if (page) params.append('page', page);
    if (technicianType) params.append('technicianType', technicianType);
    if (pageSize) params.append('pageSize', pageSize);

    const response = await apiClient.get(`/technician/alltechnician?${params.toString()}`);

return response.data;

  }

  const handleSearch = async () => {
    try {
      setLoading(true)
      const data = await getTechnicians({
        isActive: status,
        search: debouncedSearchTerm,
        technicianType: techinicianType,
        page: page,
        pageSize: limit,
      });
      if (data?.status === true) {

        setTechnicians(data?.technicians)
        setTotalItems(data?.totalItems)
        setTotalPages(data?.totalPages)
      } else {

        setError(data?.message)
      }

    } catch (error) {
      setError(error?.response?.data?.message || "Error fetching technicians")
    }
    finally {
      setLoading(false)
    }
  }
  // const handleStatusChange = (e) => {
  //   setStatus(e.target.value === 'true');
  // };

  const handleStatusChange = (e) => {
  const value = e.target.value;
  setStatus(value);

  handleSearch({
    isActive: value,
    search: debouncedSearchTerm,
    technicianType: techinicianType,
    page: page,
    pageSize: limit,
  });
};
// useEffect(() => {
//   handleSearch();
// }, [status, searchTerm, techinicianType, page]);

useEffect(() => {
  handleSearch();
}, [status, debouncedSearchTerm, techinicianType, page, limit]);

  const handleTechnicianChange = (e) => {
    setTechnicianType(e.target.value);
  }

  const handleEditClick = (techinicianId) => {
    navigate("/create-edit-techinician", { state: { techinicianId } })
  }

  const handleViewClick = (techinicianId) => {
    navigate("/view-techinician-details", { state: { techinicianId } })
  }

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };


  const handleMenuClick = (event, technician) => {
    setAnchorEl(event.currentTarget);
    setSelectedTechnician(technician);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTechnician(null);
  };


  const handleDelete = async () => {
    setIsConfirmDeleteModelOpen(false)
    setLoading(true)
    try {
      const response = await apiClient.delete(`/technician/deletetechnician/${itemIdToDelete}`);
      if (response?.data?.status === true) {
        toast.success(response?.data?.message || "technicain deleted successfully")
        handleSearch()
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Error deleting technician")
    }
    finally {
      setLoading(false)
    }
  };

  const handleAddClick = () => {
    navigate("/create-edit-techinician")
  }

  const handleBankDetails = (technicianId) => {
    navigate("/create-edit-bank-details", {
      state: {
        entityId: technicianId,
        entityType: "technician"
      }
    });
  };

  useEffect(() => {
    handleSearch()
  }, [page, limit])

const handleDownload = async () => {

  try {

    const response = await apiClient.get('/technician/download/technicains', {
      responseType: "blob",
    });

    const blob = new Blob(
      [response.data],
      {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }
    );

    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `technicians_${Date.now()}.xlsx`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

    window.URL.revokeObjectURL(url);

  } catch (error) {

    console.error("Download failed:", error);

  }
};


  return (
    <>
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Box
  sx={{
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 3
  }}
>
  <Typography variant="h3">Technicians</Typography>

  <Box sx={{ display: 'flex', gap: 2 }}>
    <Button
      variant="contained"
      sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
      onClick={handleDownload}
    >
      <FileDownloadIcon fontSize="small" />
      <Typography>Download</Typography>
    </Button>

    <Button
      variant="contained"
      sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
      onClick={handleAddClick}
    >
      <Plus size={23} />
      <Typography>Add Technician</Typography>
    </Button>
  </Box>
</Box>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, gap: 2, flexWrap: "wrap" }}>
          <Box
  sx={{
    display: "flex",
    gap: 2,
    alignItems: "center",
    flexWrap: "wrap",
  }}
>
  {/* SEARCH */}
  <TextField
    variant="outlined"
    size="small"
    placeholder="Search by name,email or phone"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon fontSize="small" />
        </InputAdornment>
      ),
    }}
    sx={{
      flex: 2,        // 👈 takes more space
      minWidth: 290,  // 👈 prevents shrinking too much
    }}
  />

  {/* STATUS */}
  <FormControl
    size="small"
    sx={{
      flex: 1,
      minWidth: 160,
    }}
  >
    <InputLabel id="status-label">Status</InputLabel>
    <Select
      labelId="status-label"
      value={status}
      label="Status"
      onChange={handleStatusChange}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="true">Active</MenuItem>
      <MenuItem value="false">Inactive</MenuItem>
    </Select>
  </FormControl>

  {/* TECHNICIAN TYPE */}
  <FormControl
    size="small"
    sx={{
      flex: 1,
      minWidth: 180,
    }}
  >
    <InputLabel id="technician-type-label">
      Technician Type
    </InputLabel>
    <Select
      labelId="technician-type-label"
      value={techinicianType}
      label="Technician Type"
      onChange={handleTechnicianChange}
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="freelance">Freelance</MenuItem>
      <MenuItem value="franchise">Franchise</MenuItem>
    </Select>
  </FormControl>
</Box>


          {/* Search Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, alignItems: 'center' }}>
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel>Rows per page</InputLabel>
              <Select value={limit} label="Rows per page" onChange={handleLimitChange}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
            {/* <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              sx={{ borderRadius: "8px", padding: "8px 20px", display: "flex", gap: 1 }}
            >
              <SearchIcon size={18} />
              <Typography>Search</Typography>
            </Button> */}
          </Box>
        </Box>



        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="100px">
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={1}>
            <Table>
              <TableHead>
                <TableRow>
                  {/* <TableCell><strong>Image</strong></TableCell> */}
                  <TableCell><strong>Name</strong></TableCell>
                  <TableCell><strong>Email</strong></TableCell>
                  <TableCell><strong>Phone</strong></TableCell>
                  <TableCell><strong>Technician Type</strong></TableCell>
                  <TableCell><strong>Is Active</strong></TableCell>
                  <TableCell align='right'><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {technicians.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      No technicians found.
                    </TableCell>
                  </TableRow>
                ) : (
                  technicians.map((technicians) => (
                    <TableRow key={technicians.id}>
                      {/* <TableCell>
                        <img
                          src={banners.bannerUrl}
                          alt={banners?.name}
                          style={{ width: 70, height: 70, borderRadius: 5 }}
                        />
                      </TableCell> */}
                      <TableCell>{technicians?.firstName} {technicians.lastName}</TableCell>
                      <TableCell>{technicians.email}</TableCell>
                      <TableCell>{technicians.phone}</TableCell>
                      <TableCell>{technicians.technicianType}</TableCell>

                      <TableCell>{technicians?.isActive === true ? "true" : "false"}</TableCell>
                      {/* <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end', gap: 1 }}>
                          <IconButton onClick={() => handleEditClick(technicians.id)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton onClick={() => handleViewClick(technicians.id)}>
                            <EyeIcon />
                          </IconButton>
                          <IconButton color="error"
                            onClick={() => handleDelete(technicians.id)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          <Button variant='outlined' onClick={()=>handleBankDetails(technicians.id)}>
                            Bank details 
                          </Button>
                        </Box>
                      </TableCell> */}

                      <TableCell align='right'>
                        <IconButton onClick={(e) => handleMenuClick(e, technicians)}>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
            >
              <MenuItem onClick={() => {
                handleEditClick(selectedTechnician?.id);
                handleMenuClose();
              }}>Edit</MenuItem>

              <MenuItem onClick={() => {
                handleViewClick(selectedTechnician?.id);
                handleMenuClose();
              }}>View</MenuItem>

              <MenuItem onClick={() => {
                confirmDelete(selectedTechnician?.id);
                handleMenuClose();
              }}>Delete</MenuItem>

              <MenuItem onClick={() => {
                handleBankDetails(selectedTechnician?.id);
                handleMenuClose();
              }}>Bank Details</MenuItem>
            </Menu>

          </TableContainer>
        )}
        {error && (
          <Box sx={{ mt: 2, color: 'red', }}>
            <Typography variant="body2" color='error'>{error}</Typography>
          </Box>
        )}



      </Box>

      {totalItems > 0 && (
        <Box mt={2} display="flex" justifyContent="center" alignItems="center">
          <Pagination
            count={totalPages > 0 ? totalPages : 1}
            page={page > totalPages ? totalPages : page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            showFirstButton
            showLastButton
            disabled={totalPages === 0}
            siblingCount={0}
            boundaryCount={1}
            sx={{
              '& .MuiPaginationItem-root': {
                height: 30,
                minWidth: 30,
                fontSize: '1rem',
                // marginTop: '10px'
                margin: "15px"
              }
            }}
          />
        </Box>
      )}

       <DeleteConfirm open={isConfirmDeleteModelOpen} onClose={() => setIsConfirmDeleteModelOpen(false)} onConfirm={handleDelete} />

    </>
  )
}

export default DisplayTechnician
